import {useContext} from 'react';
import {useDispatch} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {deriveIdFromCanvasObject} from '~/common/canvas/utils/canvas';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {UPDATE_PRISTINE_UYO} from '~/common/fabric/reducers/fabricDesign/constants';
import {useIsMediumAndUp} from '~/common/hooks/useMatchQuery';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {DeleteIcon} from '~library/svg/DeleteIcon';
import {charcoal, pebble} from '~libSass/base/_exports.sass';

export const DeleteButton = ({disabled}) => {
  const {canvas} = useContext(FabricContext);
  const dispatch = useDispatch();
  const isMediumAndUp = useIsMediumAndUp();

  const removeUYOImage = () => {
    const canvasObjects = canvas.getObjects();
    const activeObject = canvas.getActiveObject();
    let id;
    if (activeObject?.type === 'uYOImage' && activeObject._element?.src) {
      id = activeObject?.id || deriveIdFromCanvasObject(activeObject._originalObject);
      dispatch({type: UPDATE_DESIGN_OPTIONS, payload: {shouldUseCachedGalleryPhoto: false}});
      canvas.remove(activeObject);
      canvas.discardActiveObject();
      canvas.renderAll();
      canvas.fire('object:removed');
      for (const obj of canvasObjects) {
        if (obj.type === 'rect') {
          obj.set({backgroundColor: 'rgb(128,128,128,0.5)', fill: 'transparent', type: 'uYOImage'});
          canvas.renderAll();
          canvas.fire('object:modified');
        }
      }

      dispatch({
        type: UPDATE_PRISTINE_UYO,
        payload: {pristineUyo: true, id, activeCardEditor: 'intro'},
      });
    }
  };

  return (
    <Button
      variant="unstyled-button"
      className="uyo-control-btn uyo-control-btn--delete"
      onClick={removeUYOImage}
      data-qa-id="uyo-control-delete-btn"
    >
      <DeleteIcon className="action_button__upload" color={disabled ? pebble : charcoal} />
      <Typography variant="paragraph3" size="medium" color={disabled ? 'pebble' : 'charcoal'}>
        {`Remove${isMediumAndUp ? ' current' : ''}`}
      </Typography>
    </Button>
  );
};
